import { ClubSlug } from '@/staff/domain/club/ClubSlug';
import { Donations } from '@/staff/domain/donation/Donations';
import { InjectionKey } from 'vue';

export const donationRepositoryKey: InjectionKey<DonationRepository> = Symbol();

export interface DonationRepository {
  getByClub(clubSlug: ClubSlug): Promise<Donations>;
}
